import { combineReducers } from 'redux'

import sops from './sops-reducer'

export default combineReducers({
  sops,
})
